import { propName } from './prop-name.js';
import { tuple } from './tuple.js';
import { oneOf, string } from './type-checkers.js';
const propFormatters = string
    .type('formatters');
const formatters = tuple([propName, propFormatters])
    .group('formatters');
function customFormatters(props) {
    return tuple([oneOf(props), propFormatters]).group('formatters');
}
export { customFormatters, formatters, };
//# sourceMappingURL=formatters.js.map